export enum HomeApiRoutes {
  RatesSearch = '/HomeRates/search',
  PlanPaymentDetailsCalculate = '/HomeRates/plan-payment-details/calculate',
  AdjustmentPaymentDetailsCalculate = '/HomeRates/adjustments/calculate',
  HomeQuotes = '/home-quotes',
  ById = '/home-quotes/:id',
  ContactInfo = '/home-quotes/:id/contact-info',
  HomeDetails = '/home-quotes/:id/home-details',
  SelectPlan = '/home-quotes/:id/select-plan',
  AdditionalPolicyHolders = '/home-quotes/:id/additional-policy-holders',
  Cart = '/home-quotes/:id/cart',
  PaymentDetails = '/home-quotes/:id/payment-details',
  ProcessPayment = '/home-quotes/:id/process-payments',
  SoldByRep = '/home-quotes/:id/sold-by-rep',
  WrapCall = '/home-quotes/:id/wrap-call',
  CompleteRecap = '/home-quotes/:id/complete-recap',
  VerificationChecklist = '/home-quotes/:id/verification-checklist',
  EmailContract = '/home-quotes/:id/email-contract',
  MailContract = '/home-quotes/:id/mail-contract',
  CancelQuote = '/home-quotes/:id/cancel',
  CreateRetention = '/home-quotes/:id/retention',
  Retentions = '/home-quotes/:id/retentions',
  ContractAdjustmentPolicy = '/HomeContracts/:id/adjustments/policy',
  ContractClaims = '/HomeContracts/:id/claims',
  ApplyContractAdjustment = '/HomeContracts/:id/adjustments/apply',
  RequestContractCancellation = '/HomeContracts/:id/request-cancellation',
  CompleteContractCancellation = '/HomeContracts/:id/complete-cancellation',
}
